import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { JudetService } from '../judet.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-edit-judet',
  templateUrl: './edit-judet.component.html',
  styleUrls: ['./edit-judet.component.scss']
})
export class EditJudetComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error
  errorIcon: string = environment.config.customNotifications.icons.error
  errorType: string = environment.config.customNotifications.icons.error

  token!: string;
  isLoading = false;

  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name),
    slug: new FormControl('administrator'),
    observations: new FormControl(''),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditJudetComponent>,
    private judetService: JudetService, 
    private notificationService: NotificationService,
    private authService: AuthService) {
      this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token
      this.judetService.setToken(token);
    });
  }
  
  submitForm() {
    this.isLoading = true;

    const updatedJudetData = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      observations: this.form.get('observations')?.value,
      id: this.data.id,
    };

    this.judetService.updateJudet(updatedJudetData)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
      next: () => {
        this.dialogRef.close({success:true})
      },
      error: (err) => {
        let errorMessage = environment.config.customNotifications.generalMessages.error;
        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon)
      }
    })
  }
}
